<template>
	<div
		class="display-message"
		:style="{ color: theme.mainTextColor }"
	>
		{{ localization.creditApp.creationPage.createErrorMessage[language] }}<br />
		{{ localization.creditApp.creationPage.createErrorMessage2[language] }}
		<router-link>{{ localization.creditApp.creationPage.createErrorAction[language] }}</router-link>
	</div>
</template>

<script>
	import LOCALIZATION from '@core/classes/Localization';

	export default {
		name: 'LoginError',
		props: ['theme', 'language'],
		data() {
			return {};
		},
		computed: {
			localization() {
				return LOCALIZATION;
			},
		},

		methods: {},
		components: {},
	};
</script>

<style></style>
